import type { PrimarySurface, ResourceCode } from '@aztec-realms/shared-types';

import { navigationArtManifest } from './navigation-art';
import { resourceArtManifest } from './resource-art';

interface GlyphIconProps {
  surface: PrimarySurface;
  className?: string;
}

export function GlyphIcon({ surface, className }: GlyphIconProps) {
  const art = navigationArtManifest[surface];
  return (
    <img
      aria-hidden="true"
      alt=""
      className={className}
      data-navigation-art={art.id}
      decoding="async"
      draggable={false}
      width={32}
      height={32}
      src={art.url}
    />
  );
}

interface ResourceIconProps {
  resource: ResourceCode;
  className?: string;
}

export function ResourceIcon({ resource, className }: ResourceIconProps) {
  const art = resourceArtManifest[resource];
  return (
    <img
      aria-hidden="true"
      alt=""
      className={className}
      data-resource-art={art.id}
      decoding="async"
      draggable={false}
      width={28}
      height={28}
      src={art.url}
    />
  );
}
